var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClean(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00065 1.33398C4.31398 1.33398 1.33398 4.31398 1.33398 8.00065C1.33398 11.6873 4.31398 14.6673 8.00065 14.6673C11.6873 14.6673 14.6673 11.6873 14.6673 8.00065C14.6673 4.31398 11.6873 1.33398 8.00065 1.33398ZM10.8678 10.8671C10.6078 11.1271 10.1878 11.1271 9.92778 10.8671L8.00111 8.94047L6.07444 10.8671C5.81444 11.1271 5.39444 11.1271 5.13444 10.8671C5.00961 10.7426 4.93945 10.5735 4.93945 10.3971C4.93945 10.2208 5.00961 10.0517 5.13444 9.92714L7.06111 8.00047L5.13444 6.0738C5.00961 5.94925 4.93945 5.78015 4.93945 5.6038C4.93945 5.42746 5.00961 5.25836 5.13444 5.1338C5.39444 4.8738 5.81444 4.8738 6.07444 5.1338L8.00111 7.06047L9.92778 5.1338C10.1878 4.8738 10.6078 4.8738 10.8678 5.1338C11.1278 5.3938 11.1278 5.8138 10.8678 6.0738L8.94111 8.00047L10.8678 9.92714C11.1211 10.1805 11.1211 10.6071 10.8678 10.8671Z",
    fill: "#5E6062"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClean);
export default __webpack_public_path__ + "static/media/clean.c1492561849a7a2fba5703526c72f20c.svg";
export { ForwardRef as ReactComponent };